import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useClienteContext } from '../../../../contexts/ClienteContext';
import { useEmpresaContext } from '../../../../contexts/EmpresaContext';
import axiosAuth from '../../../../services/axiosAuth';
import FiltroFechas from '../../FiltroFechas/FiltroFechas';
import DetalleMovStockPesos from '../../DetalleMovStock/DetalleMovStockPesos';
import { calcularSaldoTotalMovPesos } from '../../../../services/calculaSaldoTotalMovPesos';
import { calcularSaldoAnteriorMovPesos } from '../../../../services/calculaSaldoAnteriorMovPesos';
import { calcularSaldoTotalMovPesosFiltrados } from '../../../../services/calculaSaldoTotalMovPesosFiltrados';
import { calcularSaldoMovFiltradosPesos } from '../../../../services/calculaSaldoMovFiltradosPesos';
import { calcularSaldoMovPesos } from '../../../../services/calculaSaldoMovVentasPesos';
import { generarPdfPesos } from '../../../../services/generaPdfMovPesosFiltrados';
import imagenfondo from '../../../../images/logo-sur.jpg';
import imagenFondoIntegral from '../../../../images/logo-nuevo-srl.jpg';
import { ChevronUp, ChevronDown, FileText, BookOpen, AlertCircle, Loader2 } from 'lucide-react';



const COLUMNAS = [
    { label: 'Fecha', title: '' },
    { label: 'FechaVto', title: 'Fecha de Vencimiento' },
    { label: 'N° Comprobante', title: '' },
    { label: 'T.M', title: 'Tipo Movimiento' },
    { label: 'C.V', title: 'Condición Venta' },
    { label: 'V.A', title: 'Venta Anticipada' },
    { label: 'Debe', title: '' },
    { label: 'Haber', title: '' },
    { label: 'Saldo', title: '' },
    { label: 'Nota', title: 'Nota Movimiento' },
    { label: '', title: 'Detalle' },
    { label: '', title: 'PDF' },
];

const fmtARS = (n) => Number(n).toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });

export default function TablaMovVentasPesos() {
    const sucursal = localStorage.getItem('sucursal');
    const fondo = sucursal === 'sur' ? imagenfondo : imagenFondoIntegral;

    const location = useLocation();
    const opcion = new URLSearchParams(location.search).get('opcion');

    const { getCliente } = useClienteContext();
    const data = getCliente();
    const codigo = data.codigoCliente;
    const { getEmpresa } = useEmpresaContext();
    const empresa = getEmpresa();

    const [movVentas, setMovVentas] = useState([]);
    const [mensajeError, setMensajeError] = useState('');
    const [loading, setLoading] = useState(false);
    const [fechaDesde, setFechaDesde] = useState('');
    const [fechaHasta, setFechaHasta] = useState('');
    const [registrosFiltrados, setRegistrosFiltrados] = useState([]);
    const [registrosSaldoAnterior, setRegistrosSaldoAnterior] = useState([]);
    const [estadoImprimir, setEstadoImprimir] = useState(false);
    const [showFiltrado, setShowFiltrado] = useState(false);
    const [showScrollButtons, setShowScrollButtons] = useState(false);
    const [detalleMovStock, setDetalleMovStock] = useState([]);
    const [showDetalle, setShowDetalle] = useState(false);
    const [mensajeErrorDetalle, setMensajeErrorDetalle] = useState('');
    const [selectedMov, setSelectedMov] = useState('');

    const tableContainerRef = useRef(null);

    const saldoTotal = calcularSaldoTotalMovPesos(movVentas);
    const saldoAnterior = calcularSaldoAnteriorMovPesos(registrosSaldoAnterior);
    const saldoTotalFiltrados = calcularSaldoTotalMovPesosFiltrados(registrosFiltrados, saldoAnterior);
    const saldoCalculadoFiltrados = calcularSaldoMovFiltradosPesos(registrosFiltrados, saldoAnterior);
    const saldoCalculado = calcularSaldoMovPesos(movVentas);

    useEffect(() => {
        fetchData();
        const now = new Date();
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        const fmt = (d) => d.toISOString().split('T')[0];
        setFechaDesde(fmt(firstDay));
        setFechaHasta(fmt(lastDay));
        setShowFiltrado(false);
        setEstadoImprimir(false);
    }, [codigo, opcion]);

    useEffect(() => {
        if (tableContainerRef.current) {
            const { scrollHeight, clientHeight } = tableContainerRef.current;
            setShowScrollButtons(scrollHeight > clientHeight);
            tableContainerRef.current.scrollTop = scrollHeight;
        }
    }, [movVentas, registrosFiltrados]);

const fetchData = async () => {
    if (!codigo || !sucursal) { setMensajeError('Código de cliente o sucursal no definido'); return; }
    setLoading(true);
    setMensajeError('');
    try {
        // Request 1 — primeros 100 al instante
        const response = await axiosAuth.get(`/movventas/${sucursal}/pesos/${codigo}?opcion=${opcion}&limit=50`);
        setMovVentas(response?.data);
        setLoading(false);

        // Request 2 — resto en background
        try {
            const total = await axiosAuth.get(`/movventas/${sucursal}/pesos/${codigo}?opcion=${opcion}`);
            if (total?.data?.length > response?.data?.length) {
                setMovVentas(total?.data);
            }
        } catch (e) {
            console.warn('No se pudieron cargar todos los registros:', e.message);
        }

    } catch (error) {
        setMensajeError(error.response?.data?.message);
        setLoading(false);
    }
};

    const handleFiltrarClick = () => {
        const fieldToUse = opcion == 'FechavtoFormateada' ? 'FechavtoFormateada' : 'FechaFormateada';
        const anteriores = movVentas?.filter(r => new Date(r[fieldToUse]) < new Date(fechaDesde));
        setRegistrosSaldoAnterior(anteriores?.length > 0 ? anteriores : []);
        const filtrados = movVentas?.filter(r => {
            const fecha = new Date(r[fieldToUse]);
            return fecha >= new Date(fechaDesde) && fecha <= new Date(fechaHasta);
        });
        setRegistrosFiltrados(filtrados?.length > 0 ? filtrados : []);
        setShowFiltrado(true);
        setMensajeError(filtrados?.length > 0 ? '' : 'NO EXISTEN REGISTROS EN EL RANGO DE FECHAS');
        setEstadoImprimir(filtrados?.length > 0);
    };

    const handleImprimirClick = () => {
        generarPdfPesos(registrosFiltrados, data, empresa, fechaDesde, fechaHasta, saldoAnterior, saldoCalculadoFiltrados, saldoTotalFiltrados, opcion);
    };

    const handleVisualizarDetalle = async (Clave, mov) => {
        setSelectedMov(mov);
        try {
            const response = await axiosAuth.get(`/movstock/${sucursal}/movventas/${Clave}`);
            setDetalleMovStock(response?.data);
            setShowDetalle(true);
            setMensajeErrorDetalle('');
        } catch (error) {
            setShowDetalle(true);
            setMensajeErrorDetalle(error.response?.data?.message);
        }
    };

    const handleDescargarPdfPorClave = async (clave) => {
        try {
            const response = await axiosAuth.get(`/movventas/${sucursal}/imagen/${clave}`);
            const bin = atob(response.data.Imagen);
            const arr = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
            window.open(URL.createObjectURL(new Blob([arr], { type: 'application/pdf' })), '_blank');
        } catch (error) {
            console.error('Error al obtener el PDF:', error);
        }
    };

    const registros = showFiltrado ? registrosFiltrados : movVentas;
    const saldos = showFiltrado ? saldoCalculadoFiltrados : saldoCalculado;

    return (
        <div className="flex flex-col h-full bg-white">

            {/* HEADER */}
            <div className="flex-shrink-0 bg-[#050f08] border-b border-gray-700">
                <div className="px-4 py-1 flex flex-col items-center gap-1">
                    <p className="text-white font-bold text-xs tracking-widest uppercase text-center">
                        Histórico en Pesos por {opcion == 'FechavtoFormateada' ? 'fecha de vencimiento' : 'fecha de factura'}
                    </p>
                    <p className="text-gray-400 text-[10px] uppercase tracking-wider">
                        Actualizado: {new Date(empresa?.updatedAt)?.toLocaleString('es-ES', { hour12: false })}
                    </p>
                </div>
            </div>

            {/* FILTRO */}
            <div className="flex-shrink-0 bg-white border-b border-gray-200 px-3 py-2">
                <FiltroFechas
                    handleFiltrarClick={handleFiltrarClick}
                    estadoImprimir={estadoImprimir}
                    handleImprimirClick={handleImprimirClick}
                    setFechaDesde={setFechaDesde}
                    setFechaHasta={setFechaHasta}
                    fechaDesde={fechaDesde}
                    fechaHasta={fechaHasta}
                />
            </div>

            {/* SALDO ANTERIOR */}
            {showFiltrado && (
                <div className="flex-shrink-0 bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-center">
                    <span className="text-amber-800 text-xs font-black uppercase tracking-widest">
                        Saldo anterior: {fmtARS(saldoAnterior)}
                    </span>
                </div>
            )}

            {/* TABLA */}
            <div className="overflow-auto relative flex-1" ref={tableContainerRef}
                style={{
                    backgroundImage: `url(${fondo})`,
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    // maxHeight: 'calc(100vh - 220px)'
                }}>

                {loading && (
                    <div className="absolute inset-0 bg-white/80 flex items-center justify-center z-10">
                        <div className="flex flex-col items-center gap-3">
                            <Loader2 size={28} className="text-gray-400 animate-spin" />
                            <span className="text-gray-400 text-xs uppercase tracking-widest font-bold">Cargando...</span>
                        </div>
                    </div>
                )}

                {!loading && mensajeError && (
                    <div className="m-4 flex items-center gap-3 bg-red-50 border border-red-200 rounded-xl px-4 py-3">
                        <AlertCircle size={16} className="text-red-400 flex-shrink-0" />
                        <p className="text-red-600 text-xs font-black uppercase tracking-wider">{mensajeError}</p>
                    </div>
                )}

                <table className="w-full border-collapse text-xs">
                    <thead>
                        <tr className="bg-gray-800 sticky top-0 z-10">
                            {COLUMNAS.map((col, i) => (
                                <th key={i} title={col.title}
                                    className="sticky top-0 px-2 py-1 border-r border-gray-700 text-white/80 font-bold uppercase tracking-wider whitespace-nowrap text-center last:border-r-0">
                                    {col.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {registros?.map((mov, index) => (
                            <tr key={index} className="bg-white/85 hover:bg-blue-200 transition-colors border-b border-gray-200 text-center">
                                <td className="px-2 py-1 border-r border-gray-100 whitespace-nowrap text-gray-700">{mov?.Fecha}</td>
                                <td className="px-2 py-1 border-r border-gray-100 whitespace-nowrap text-gray-700">{mov?.Fechavto}</td>
                                <td className="px-2 py-1 border-r border-gray-100 whitespace-nowrap text-right text-gray-700">
                                    {mov?.Letrafactura ? mov?.Letrafactura + ' - ' : ''}{mov?.Talonario} - {mov?.Nrocomprobante}
                                </td>
                                <td className="px-2 py-1 border-r border-gray-100 text-gray-600">{mov?.Tipomov}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-gray-600">{mov?.Condvta}</td>
                                <td className="px-2 py-1 border-r border-gray-100 text-green-600 font-bold">
                                    {mov?.Ventaanticipada == '1' ? '✔' : ''}
                                </td>
                                <td className="px-2 py-1 border-r border-gray-100 text-right whitespace-nowrap text-red-600 font-semibold">
                                    {saldos[index]?.debe ? fmtARS(saldos[index].debe) : ''}
                                </td>
                                <td className="px-2 py-1 border-r border-gray-100 text-right whitespace-nowrap text-green-600 font-semibold">
                                    {saldos[index]?.haber ? fmtARS(saldos[index].haber) : ''}
                                </td>
                                <td className="px-2 py-1 border-r border-gray-100 text-right whitespace-nowrap font-black text-gray-900">
                                    {fmtARS(saldos[index]?.saldo)}
                                </td>
                                <td className="px-2 py-1 border-r border-gray-100 text-left text-gray-500 max-w-[120px] truncate"
                                    title={mov?.Notamovimiento}>
                                    {mov?.Notamovimiento}
                                </td>
                                <td className="px-2 py-1 border-r border-gray-100">
                                    <button onClick={() => handleVisualizarDetalle(mov?.Clave, mov)}
                                        className="flex items-center justify-center mx-auto text-gray-400 hover:text-blue-600 transition-colors">
                                        <BookOpen size={15} />
                                    </button>
                                </td>
                                <td className="px-2 py-1">
                                    {(mov?.tieneImagen == 1 || mov?.tieneImagen == '1') && (
                                        <button onClick={() => handleDescargarPdfPorClave(mov?.Clave)}
                                            className="flex items-center justify-center mx-auto text-gray-400 hover:text-red-500 transition-colors">
                                            <FileText size={15} />
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* FOOTER */}
            <div className="flex-shrink-0 bg-[#050f08] px-4 py-4 md:py-0.5 lg:py-0.5  flex items-center justify-between">
                <span className="text-gray-400 text-[12px] md:text-[10px] lg:text-[10px] uppercase tracking-widest font-bold">Saldo total</span>
                <span className="text-white font-black text-sm tracking-wider">
                    {fmtARS(showFiltrado ? saldoTotalFiltrados : saldoTotal)}
                </span>
                {showScrollButtons && (
                    <div className="flex gap-2">
                        <button onClick={() => tableContainerRef.current.scrollTop = 0}
                            className="w-12 h-12  md:w-7 md:h-7 lg:w-7 lg:h-7 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center text-white transition-all">
                            <ChevronUp size={14} />
                        </button>
                        <button onClick={() => tableContainerRef.current.scrollTop = tableContainerRef.current.scrollHeight}
                            className="w-12 h-12  md:w-7 md:h-7 lg:w-7 lg:h-7 bg-gray-700 hover:bg-gray-600 rounded-full flex items-center justify-center text-white transition-all">
                            <ChevronDown size={14} />
                        </button>
                    </div>
                )}
            </div>

            {/* MODAL DETALLE */}
            {showDetalle && (
                <DetalleMovStockPesos
                    detalleMovStock={detalleMovStock}
                    onClose={() => { setShowDetalle(false); setDetalleMovStock(''); }}
                    mensajeError={mensajeErrorDetalle}
                    movVenta={selectedMov}
                />
            )}
        </div>
    );
}